<template>
  <div
    class="detail-card"
    :class="{ 'unite_card ': isUnite }"
    @click="handleClick($event)"
  >
    <div
      v-if="isUnite"
      class="card-choose__circle circle-color"
      :class="{ chooseCard: chooseUnite }"
    ></div>
    <div class="detail-card__title">
      <span class="detail-card__tag tag subject">
        {{ data.subjects[0].short_name }}
      </span>
      <span class="detail-card__title__name" v-html="xss(data.name)"></span>
      <p class="detail-card__price">
        <span
          v-if="Number(data.price.resale) !== Number(data.price.origin)"
          class="orig-price"
          >¥{{ data.price.origin }}</span
        >￥{{ data.price.resale }}
      </p>
    </div>
    <div class="detail-card__info">
      <p class="detail-card__info__item">
        {{ data.schoolTimeName }} · 共{{ data.syllabusNum }}讲
      </p>
      <p
        class="detail-card__info__item"
        v-if="
          data.difficulty && data.difficulty.alias && !/\D/.test(data.difficulty.alias)
        "
      >
        难度：<i
          v-for="index of Number(data.difficulty.alias)"
          :key="index"
          class="iconfont2 icon-star-fill"
        ></i>
      </p>
      <!-- <p class="detail-card__info__item " v-html="data.secondTitle">剑桥大学出版社倾力打造</p> -->
    </div>
    <div class="detail-card__teacher">
      <!--主讲老师-->
      <dialog-card-teacher
        v-if="teacherList && teacherList.length > 0"
        :data="teacherList"
      />
<!--      &lt;!&ndash;外交老师&ndash;&gt;-->
<!--      <dialog-card-teacher-->
<!--        v-if="foreignTeacherList && foreignTeacherList.length > 0"-->
<!--        :data="foreignTeacherList"-->
<!--        :title="foreignTeacherList[0].title"-->
<!--      />-->
<!--      &lt;!&ndash;助教老师&ndash;&gt;-->
<!--      <template v-if="data.isHaveCounselorTeacher === 1">-->
<!--        <dialog-card-teacher-->
<!--          :title="data.class.counselor.typeName"-->
<!--          :excTeacherCourse="data.excTeacherCourse"-->
<!--          :leftNum="data.class.leftNum"-->
<!--          :isCounselorTeacher="data.class.isHaveCounselorTeacher"-->
<!--          :data="[-->
<!--            {-->
<!--              id: data.class.id,-->
<!--              name: data.class.counselor.name,-->
<!--              avatar: data.class.counselor.avatars[0],-->
<!--              description: data.class.counselor.description-->
<!--            }-->
<!--          ]"-->
<!--        />-->
<!--      </template>-->
    </div>
  </div>
</template>

<script>
import xss from 'xss'
import DialogCardTeacher from './DialogCardTeacher'
export default {
  props: ['data', 'isUnite'],
  data() {
    return {
      xss,
      chooseUnite: true
    }
  },
  components: {
    DialogCardTeacher
  },
  computed: {
    teacherList() {
      const { chinaTeacher, foreignTeacher, counsolerInfo } = this.courseDetail.teacherModule
      const teacherListArr = []
      if (chinaTeacher && chinaTeacher.length)  {
        teacherListArr.push(...chinaTeacher)
      }
      if (foreignTeacher && foreignTeacher.length)  {
        teacherListArr.push(...foreignTeacher)
      }
      if (counsolerInfo && counsolerInfo.length)  {
        teacherListArr.push(...counsolerInfo)
      }
      return teacherListArr
    },
    chineseTeacherList() {
      if (this.data.chineseTeacher && this.data.chineseTeacher.length > 0) {
        return this.data.chineseTeacher.map(item => {
          return {
            id: item.id,
            title: item.typeName,
            name: item.name,
            url: item.spell,
            avatar: item.avatars[0],
            description: item.description
          }
        })
      }
      return []
    },
    foreignTeacherList() {
      if (this.data.foreignTeacher && this.data.foreignTeacher.length > 0) {
        return this.data.foreignTeacher.map(item => {
          return {
            id: item.id,
            title: item.typeName,
            name: item.name,
            url: item.spell,
            avatar: item.avatars[0],
            description: item.description
          }
        })
      }
      return []
    }
  },
  methods: {
    handleClick(event) {
      this.chooseUnite = !this.chooseUnite
      this.$emit('chooseCourse', this.chooseUnite)
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/scss/entry';
@import 'src/views/CourseDetail/index.scss';
@import 'src/views/CourseDetail/common.scss';
@include b(detail-card) {
  position: relative;
  padding: 24px 32px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(229, 229, 229, 1);
  @include e(title) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    position: relative;
    @include e(name) {
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: rgba(51, 51, 51, 1);
      line-height: 16px;
      overflow: hidden;
      width: 420px;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    &:hover {
      .circle-color {
        border: 1px solid #f13232;
        opacity: 1;
      }
    }
  }
  @include e(info) {
    @include e(item) {
      margin-top: 12px;
      font-size: 12px;
      color: #666666;
      width: 420px;
      & > i {
        font-size: 12px;
      }
    }
  }
  @include e(teacher) {
    margin-top: 20px;
    margin-left: -10px;
    margin-right: -10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
  @include e(tag) {
    font-size: 12px;
    line-height: 12px;
  }
  @include e(price) {
    position: absolute;
    right: 0;
    font-size: 16px;
    font-family: MicrosoftYaHei;
    color: rgba(241, 50, 50, 1);
    line-height: 16px;
  }
}

.card-choose__circle {
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 24px;
  width: 16px;
  height: 16px;
  color: #d9d9d9;
  border-radius: 100%;
  margin-right: 8px;
  background: #ffffff;
  border: 1px solid #d9d9d9;
}
.chooseCard {
  background-image: url('~@/views/AddPurchase/img/choose.png');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border: 1px solid #f13232;
}
.unite_card {
  background: rgba(245, 245, 245, 0.8);
  padding-left: 60px;
}
.orig-price {
  text-decoration: line-through;
  font-size: 12px;
  color: #707070;
  margin-right: 8px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/NewCourseDetail/modules/BuyDialogCard.vue